<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="指标设定"
      :expand-all-row="true"
      :page="true"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      :show-reset="true"
      table-title="信息列表"
      :custom-search="customSearch"
      @count="query()"
      @reset="reset"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange" size="mini">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <tree-select
            ref="treeSelect"
            :props="props"
            size="mini"
            :options="TreeData"
            :value="params.ClassId"
            :clearable="true"
            :accordion="true"
            style="width:100%"
            :parentSelect="false"
            placeholder="请选择"
            @node-select="onTreeSelect($event)"
          />
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column">
          <el-table-column prop="ClassName" label="班级"/>
          <el-table-column prop="IndexHigh" label="高分（年级前5%）指标数" />
          <el-table-column prop="Index985" label="985（年级前35%）指标数" />
          <el-table-column prop="Index211" label="211（年级前65%）指标数" />
          <el-table-column prop="IndexSc" label="特控（年级前5%）指标数" />
        </slot>
      </template>
    </list>
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import treeSelect from "@/components/common/treeSelect";
import importDialog from "./importDialog";

export default {
  mixins: [listMixin],
  components: { 
    list,
    treeSelect,
    importDialog
  },
  data() {
    return {
      api: require("@/api/ed/class").default,
      alcApi: require("@/api/analyse/analyseclass").default,
      termApi: require("@/api/ed/term").default,
      classApi: require("@/api/ed/class").default,
      params: {
        TermId: null,
        ClassId: null,
      },
      TermName: "",
      customSearch: [
        { bn: "查询", fn: 'count' },
      ],
      props: {
        // 配置项（必选）
        value: "ClassId",
        label: "FullName",
        children: "children",
      },
      termList: [],
      TreeData: [],
    };
  },
  beforeMount() {
    this.termApi.list({}).then(res => {
      if (res.Code == 0) {
        this.termList = res.Data;
        this.params.TermId = res.Data[0].TermId;
        this.TermName = res.Data[0].TermName;
        this.$refs.list.initQueryParams.TermId = this.params.TermId;
        this.getTreeData(res.Data[0].TermId,true);
      }
    });
  },
  methods: {
    getTreeData(TermId,type) {
      this.classApi.gradeClassList(TermId).then((res) => {
        res.Data.forEach((e) => {
          if(e.PName) {
            e.FullName = e.PName + e.ClassName;
          } else {
            e.FullName = e.ClassName;
          }
        });
        let treeData = this.$commonJs.toTreeData(res.Data, "ClassId");
        let arr = [];
        treeData.forEach(e => {
          if(e.children) {
            arr.push(e)
          }
        })
        this.TreeData = arr;
        console.log("tree",this.TreeData)
        if(type) {
          this.query({ TermId: this.params.TermId })
        }
      });
    },
    onTreeSelect(e) {
      if(e) {
        this.params.ClassId = e.ClassId
      } else {
        this.params.ClassId = null
      }
    },
    import() {
      this.$refs.importDialog.open().then((that) => {
        that.setData(this.params.TermId,this.TermName);
      });
    },
    count() {
      this.query(this.params)
    },
    export() {
      this.alcApi.export(this.params)
    },
    reset() {
      this.$refs.treeSelect.clearHandle();
    },
    termChange(e) {
      this.$refs.treeSelect.clearHandle();
      this.getTreeData(e);
      this.params.ClassId = null;
      this.termList.forEach(n => {
        if(e == n.TermId) {
          this.TermName = n.TermName;
        }
      })
    }
  },
};
</script>
<style lang="scss">
</style>